import React from 'react'
import { Form, InputNumber } from 'antd'
import styled from 'styled-components'
import { DEFAULT_REQUIRED_FIELD_MESSAGE } from 'components/Assessments/constants'
import { NumberQuestionProps } from '../types'
import LabelAndDescriptionFieldLayout from '../FieldLayout/LabelAndDescriptionFieldLayout'
import QuestionContainer from '../QuestionContainer'

const Container = styled.div`
  margin: 16px 0;
`

function NumberQuestion({
  field,
  formFieldName,
  layout,
  disabled = false,
  required = false,
  customRules = [],
  placeholder,
  min,
  max,
  step,
  precision,
  formatter,
  parser,
  addonAfter,
  addonBefore
}: NumberQuestionProps): JSX.Element {
  // Auto-detect description from field extensions
  const secondaryText = field?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display

  // Combine default required rule with custom rules
  const allRules = [
    {
      required: Boolean(required && field.required),
      message: DEFAULT_REQUIRED_FIELD_MESSAGE
    },
    ...customRules
  ]

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <LabelAndDescriptionFieldLayout
          label={field.text}
          secondaryText={secondaryText}
          layout={layout}
        >
          <Form.Item name={formFieldName} rules={allRules} style={{ margin: 0 }}>
            <InputNumber
              disabled={disabled}
              placeholder={placeholder}
              min={min}
              max={max}
              step={step}
              precision={precision}
              formatter={formatter}
              parser={parser}
              addonAfter={addonAfter}
              addonBefore={addonBefore}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </LabelAndDescriptionFieldLayout>
      </Container>
    </QuestionContainer>
  )
}

export default NumberQuestion
